import { render, staticRenderFns } from "./ConsolidatedSalesDetail.vue?vue&type=template&id=032e5f39&"
import script from "./ConsolidatedSalesDetail.vue?vue&type=script&lang=js&"
export * from "./ConsolidatedSalesDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports